import * as React from 'react';
import { CardBig, CardLayout, CardMedium, CardSmall } from '../parts';
import { UIHeading1 } from '@cian/ui-kit';

import cn from 'clsx';

import img1 from './assets/card_1.svg';
import img2 from './assets/card_2.svg';
import img2mobile from './assets/card_2_mobile.svg';
import img3 from './assets/card_3.svg';
import img4 from './assets/card_4.svg';
import img5 from './assets/card_5.svg';
import img6_1 from './assets/card_6_1.svg';
import img6_2 from './assets/card_6_2.svg';
import img6_3 from './assets/card_6_3.svg';
import img7 from './assets/card_7.svg';

import * as styles from './styles.css';

interface IServiceCardsProps {
  isDesktop: boolean;
  newDreamOnClick: () => void;
  homeProfitOnClick: () => void;
}

export const ServiceCards: React.FC<IServiceCardsProps> = ({ isDesktop, newDreamOnClick, homeProfitOnClick }) => {
  return (
    <div className={styles['container']}>
      <UIHeading1 color="black_100" as="h2">
        Что расскажем про ваш дом
      </UIHeading1>

      <CardLayout>
        <CardSmall
          title="Стоимость и доход от аренды"
          description="Оценим и учтём всё: ремонт, этаж и даже баню на участке"
        >
          <div className={styles['card']}>
            <img src={img1} alt="" />
          </div>
        </CardSmall>

        <CardBig
          title="Мечтайте по-новому"
          description="Например, как переехать в новостройку или загород"
          onClick={newDreamOnClick}
          hasLabel
          className={isDesktop ? undefined : styles['mobile-dream-card']}
        >
          <div className={styles['card']}>
            <img src={isDesktop ? img2 : img2mobile} alt="" />
          </div>
        </CardBig>
      </CardLayout>

      <CardLayout>
        <CardSmall
          title="Как заработать на квартире"
          description="Расскажем про несколько сценариев получения дохода"
          onClick={homeProfitOnClick}
          hasLabel
        >
          <div className={styles['card']}>
            <img src={img3} alt="" />
          </div>
        </CardSmall>

        <CardSmall title="Прогноз удачного момента для продажи" description="Анализируем рынок и рассказываем вам">
          <div className={styles['card']}>
            <img src={img4} alt="" />
          </div>
        </CardSmall>

        <CardSmall title="Похожие объявления" description="Покажем недвижимость рядом для сравнения">
          <div className={styles['card']}>
            <img src={img5} alt="" />
          </div>
        </CardSmall>
      </CardLayout>

      <CardLayout>
        <CardMedium
          title="Ваш гид по недвижимости"
          description="Расскажем как подготовить недвижимость, создать эффективное объявление и составить документы для сделки"
        >
          <>
            <div className={cn(styles['card-multiply'], styles['card-1'])}>
              <img src={img6_1} alt="" />
            </div>

            <div className={cn(styles['card-multiply'], styles['card-2'])}>
              <img src={img6_2} alt="" />
            </div>

            <div className={cn(styles['card-multiply'], styles['card-3'])}>
              <img src={img6_3} alt="" />
            </div>
          </>
        </CardMedium>

        <CardMedium
          title="Один шаг до сделки"
          description="Когда решитесь продавать или сдавать, поможем быстро подать объявление. Для собственников это бесплатно"
          className={cn(styles['card-gradient'], isDesktop ? undefined : styles['mobile-step-card'])}
        >
          <div className={styles['card']}>
            <img src={img7} alt="" />
          </div>
        </CardMedium>
      </CardLayout>
    </div>
  );
};
